import React, { useState, useEffect } from "react";

import {
  colorToHex,
  getCurrentStyleTarget,
  runEditorCommand
} from "@/helpers/editor/command-style";

import { cn } from "@/lib/utils";

import ToolbarButton from "./toolbar-button";

interface Props extends React.ComponentProps<"button"> {
  editorRef: React.RefObject<HTMLDivElement>;
}

const TextColorPicker: React.FC<Props> = ({
  className,
  editorRef,
  ...props
}) => {
  const [selectedColor, setSelectedColor] = useState("#000000");

  const getSelectedTextColor = () => {
    const styleTarget = getCurrentStyleTarget(editorRef);
    if (styleTarget) {
      const color = window.getComputedStyle(styleTarget).color;
      return colorToHex(color, "#000000");
    }

    return "#000000";
  };

  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setSelectedColor(color);

    runEditorCommand(editorRef, "foreColor", color);
  };

  const updateSelectedTextColor = () => {
    const color = getSelectedTextColor();
    setSelectedColor(color);
  };

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.addEventListener("mouseup", updateSelectedTextColor);
      editorRef.current.addEventListener("keyup", updateSelectedTextColor);
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.removeEventListener(
          "mouseup",
          updateSelectedTextColor
        );
        editorRef.current.removeEventListener("keyup", updateSelectedTextColor);
      }
    };
  }, [editorRef]);

  return (
    <ToolbarButton className={cn(className)} {...props}>
      <label className="relative flex size-full justify-center">
        <span className="text-lg font-bold">A</span>
        <span
          className="absolute bottom-0 h-1 w-6 rounded-full"
          style={{ backgroundColor: selectedColor }}
        />
        <input
          type="color"
          value={selectedColor}
          onChange={handleColorChange}
          className="absolute size-0 cursor-pointer opacity-0"
          data-editor="true"
        />
      </label>
    </ToolbarButton>
  );
};

export default TextColorPicker;
